module.exports = __webpack_public_path__ + "media/images/game_icon/vi/VG1004-63c53552be11c6e32d4db5ebc742d466.png";